<ion-header>
  <ion-toolbar mode="ios">
    <ion-back-button slot="start" text="" defaultHref="/home/survey-list" color="dark" class="ion-no-padding">
      <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
    </ion-back-button>
    <ion-title class="ion-no-padding">
      <ion-img [src]="dataServ.rData.dark_logo" *ngIf="dataServ.rData.dark_logo[0]"></ion-img>
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content *ngIf="authServ.isLogged && survey" #content>
  <ng-container *ngFor="let group of survey.groups; let s = index">
    <ion-row>
      <ion-col size="12">
        <ion-card class="question-card">

          <ion-label class="question-card-title">
            {{group.group | caption}}
            <ion-icon (click)="accordionSwitch(s)" name="chevron-{{!displayContent[s]? 'forward': 'down'}}">
            </ion-icon>
          </ion-label>

          <ng-container *ngIf="!displayContent[s]">
            <ng-container *ngFor="let question of group.survey_lines ; let i = index"
              [ngSwitch]="question.question_type">
              <div class="question">
                <ion-label>
                  {{(i+1) + '. '}}{{question.question | caption}}
                </ion-label>
                <ion-label>
                  <p>{{question.description | caption}}</p>
                </ion-label>

                <app-star-rating *ngSwitchCase="'star'" [rate]="question.answer" (didRated)="question.answer = $event ">
                </app-star-rating>
                <app-nps-rating *ngSwitchCase="'nps'" [rate]="question.answer" (didRated)="question.answer = $event">
                </app-nps-rating>
                <app-boolean-rating *ngSwitchCase="'boolean'" [rate]="question.answer"
                  (didRated)="question.answer = $event" [question]="question"
                  (selectedOptions)="question.answer_response = $event">
                </app-boolean-rating>
                <app-smile-rating *ngSwitchCase="'smile'" [rate]="question.answer"
                  (didRated)="question.answer = $event">
                </app-smile-rating>

                <app-select-option *ngSwitchCase="'option'" [question]="question"
                  (selectedOptions)="question.answer_response = $event"></app-select-option>
                <ion-textarea *ngSwitchCase="'text'" [(ngModel)]="question.answer_response"></ion-textarea>
              </div>
            </ng-container>
          </ng-container>
        </ion-card>
      </ion-col>
    </ion-row>
  </ng-container>
  <ion-card class="survey-note">
    <ion-row>
      <ion-col size="12">

        <ion-item>
          <ion-textarea [(ngModel)]="surveyNotes" placeholder="{{' Notunuzu Giriniz' | translate}}">
          </ion-textarea>
        </ion-item>

      </ion-col>
      <ion-col class="submit-btn" size="12">
        <ion-button (click)="submitSurvey()">
          {{'Send' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-card>

</ion-content>
<ion-content *ngIf="!authServ.isLogged">
  <ion-row>
    <ion-col class="error" sizeLg="6" offsetLg="3" size="12">
      <ion-icon color="medium" name="log-in-outline" style="font-size: 128px;"></ion-icon><br>
      <ion-text color="medium" class="ion-margin">
        <h2> {{"Please login to answer the surveys." | translate}}</h2>
      </ion-text>
    </ion-col>
  </ion-row>
</ion-content>